// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bcw_a bhp_ea bhp_ke bhp_ju bhp_sn bhp_wl"};